exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.label[data-v-40a3d73c]{font-weight:bold\n}\n.pad[data-v-40a3d73c]{padding:15px 5px\n}\n.font14[data-v-40a3d73c]{font-size:14px\n}\n.pad-top[data-v-40a3d73c]{padding-top:10px\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/resumo/AppResumoImovelBeneficiario.vue"],"names":[],"mappings":";AAiDA,wBACE,gBAAiB;CAClB;AAAA,sBAEC,gBAAiB;CAClB;AAAA,yBAEC,cAAe;CAChB;AAAA,0BAEC,gBAAiB;CAClB","file":"AppResumoImovelBeneficiario.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.label {\n  font-weight: bold;\n}\n.pad {\n  padding: 15px 5px;\n}\n.font14 {\n  font-size: 14px;\n}\n.pad-top {\n  padding-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40a3d73c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resumo/AppResumoImovelBeneficiario.vue
// module id = Dbss
// module chunks = 11